export default __webpack_public_path__ + "be69ed4e4b80aed5f90723f307e6b0e0.svg";